import { useTranslation } from 'next-i18next';
import { FC, useEffect } from 'react';
import { gulperImpression } from 'src/common/utils/gulperImpressions';
import { useCurrencyContext } from 'src/common/providers/CurrencyProvider';

/**
 * Tracks listing card impressions.
 *
 * `data` prop can be anything that is a stable reference.
 * When `data` changes, new impressions will be tracked.
 */
const GulperImpressions: FC<{ data: string | any }> = ({ data }) => {
  const { currency } = useCurrencyContext();
  const { i18n } = useTranslation();
  useEffect(() => {
    gulperImpression();
  }, [data]);
  return (
    <div
      hidden
      data-gulper-meta
      data-gulper-lang={i18n.language}
      data-gulper-currency={currency.code}
    />
  );
};

export default GulperImpressions;
